(function () {
    'use strict';

    angular.module("imApp").factory("activityTypeDevTypeService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1236,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1237,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
